import { Component, h, Host, Listen } from '@stencil/core';

@Component({
  tag: 'mama-toggle-search',
})
export class MamaToggleSearch {
  @Listen('click')
  onClick() {
    document.body.classList.remove('offcanvas-active');
    document.body.classList.toggle('offcanvas-search-active');
  }

  render() {
    return (
      <Host>
        <svg class="search">
          <use xlinkHref="#search" />
        </svg>
      </Host>
    );
  }
}
